import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade, Pagination, Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";
import "swiper/css/navigation";

// Images
import manaliImg from "../assets/manali.png";
import shimlaImg from "../assets/shimla.png";
import dharamshalaImg from "../assets/dharamshala.png";
import dalhousieImg from "../assets/dalhousie.png";
import spitiImg from "../assets/spiti.png";
import PangiImg from "../assets/pangi-7.png";

const slides = [
  { img: manaliImg, title: "Manali", desc: "A stunning hill station surrounded by snow-capped peaks." },
  { img: shimlaImg, title: "Shimla", desc: "The Queen of Hills, known for colonial charm." },
  { img: dharamshalaImg, title: "Dharamshala", desc: "A peaceful blend of nature & Tibetan culture." },
  { img: dalhousieImg, title: "Dalhousie", desc: "Scenic views and colonial architecture." },
  { img: spitiImg, title: "Spiti Valley", desc: "High-altitude desert landscapes and monasteries." },
  { img: PangiImg, title: "Pangi Valley", desc: "Rugged terrain, deep gorges, and vibrant culture." },
];

const ImageSlider = () => {
  return (
    <Swiper
      spaceBetween={30}
      effect={"fade"}
      loop={true}
      autoplay={{ delay: 3000, disableOnInteraction: false }}
      pagination={{ clickable: true }}
      navigation={true}
      modules={[Autoplay, EffectFade, Pagination, Navigation]} // ✅ must pass here
    >
      {slides.map((slide, index) => (
        <SwiperSlide key={index}>
          <div style={{ position: "relative" }}>
            <img
              src={slide.img}
              alt={slide.title}
              style={{ width: "90%", height: "500px", objectFit: "cover", borderRadius: "10px" ,display:"flex",justifyContent:"center",margin:"auto"}}
            />
            <div
              style={{
                position: "absolute",
                bottom: "30px",
                left: "90px",
                color: "#fff",
                backgroundColor: "rgba(0,0,0,0.4)",
                padding: "15px",
                borderRadius: "10px",
              }}
            >
              <h1>{slide.title}</h1>
              <p>{slide.desc}</p>
            </div>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default ImageSlider;